import { create_instance } from '@app/plugins/axios';

export class ExtendApiService {
  constructor(opts) {
    this.http = create_instance(opts, true);
    this.pure_http = create_instance({ ...opts, resource: '' }, true);
  }
}
